import {Injectable} from '@angular/core';
import {urlJoin} from '../../../../utils/urlJoin';
import {environment} from '../../../../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {SearchObject} from '../../../../domain/search/SearchObject';
import {EPConsor} from '../../../../domain/groupement/BidClsConsor';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class GroupementService {
    constructor(private http: HttpClient) {
    }

    static get base() {
        return urlJoin(environment.server.hostSource, 'fournisseur');
    }

    searchgroupement(searchObject: SearchObject) {
        const resource = urlJoin(
            GroupementService.base,
            'vConsorApply',
            'memRegNo'
        );
        return this.http.post(resource, searchObject);
    }

    getlistlot(body: EPConsor) {
        const resource = urlJoin(
            GroupementService.base,
            'vConsorApply',
            'ListLots'
        );
        return this.http
            .post(resource, body)
            .pipe(map((response) => response['payload']));
    }

    detailsgroup(body: EPConsor) {
        const resource = urlJoin(GroupementService.base, 'vConsorApply', 'ListCls');
        return this.http
            .post(resource, body)
            .pipe(map((response) => response['payload']));
    }

    acceptergroupement(body: EPConsor) {
        const resource = urlJoin(
            GroupementService.base,
            'vConsorApply',
            'Approbation'
        );
        return this.http
            .post(resource, body)
            .pipe(map((response) => response['payload']));
    }

    checkoffreisend(body: EPConsor) {
        const resource = urlJoin(GroupementService.base, 'vConsorApply', 'send');
        return this.http
            .post(resource, body)
            .pipe(map((response) => response['payload']));
    }

    checkgrouupementisend(body: EPConsor) {
        const resource = urlJoin(GroupementService.base, 'vConsorApply', 'Consor');
        return this.http
            .post(resource, body)
            .pipe(map((response) => response['payload']));
    }

    checkGerant(bidNo, bidModSeq) {
        const resource = urlJoin(GroupementService.base, 'checkBidSupplier', 'submitManager' + `?bidNo=${bidNo}&bidModSeq=${bidModSeq}`);
        return this.http.get(resource);
    }

    hasparticipate(body) {
        const resource = urlJoin(
            GroupementService.base,
            'vConsorApply',
            'participat'
        );
        return this.http.post(resource, body);
    }


    checkIfManagerSelected(bizRegNo, bizRegNoList) {
        const resource = urlJoin(
            GroupementService.base,
            'vConsorApply',
            'checkPartici' + `?bizRegNo=${bizRegNo}&bizRegNoList=${bizRegNoList}`
        );
        return this.http.get(resource);
    }


    loadSupplierlist(refSupp) {
        const resource = urlJoin(GroupementService.base, 'vUmInst','list', 'supplier');
        return this.http.get(resource, {params: new HttpParams().set('supplier', refSupp)});
    }
}
